import * as React from 'react';
import customIconWrapper from './custom-icons';

const AddIcon = customIconWrapper(<>
	<path d="M4 12H20" stroke='currentColor' strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
	<path d="M12 20V4" stroke='currentColor' strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
</>);

export default AddIcon;
